import React from "react";
import "./styles.css";


function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer >
    <div className="footer">
    <div className="social-icons">
    <a href="https://github.com/mdilshair56/">
        <i className="bx bxl-github"></i>
    </a>
    <a href="https://www.linkedin.com/in/muhammad-dilshair-zafar/">
        <i className="bx bxl-linkedin-square"></i>
    </a>
    <a href="https://www.instagram.com/itxdilshair56/">
        <i className="bx bxl-instagram-alt"></i>
    </a>
    <a href="https://x.com/MDILRUBA56IK/">
        <i className="bx bxl-twitter"></i>
    </a>
    </div>
    <ul className="list">
      {/* <li>
        <a href="#">FAQ</a>
      </li> */}
      <li>
        <a href="#home">Home</a>
      </li>
      <li>
        <a href="#services">Services</a>
      </li>
      <li>
        <a href="#about">About Me</a>
      </li>
      <li>
        <a href="#contact">Contact</a>
      </li>
    </ul>
    
    <p className="copyright">© All Rights Reserved {currentYear} | MUHAMMAD DILSHAIR ZAFAR</p>
    </div>
    </footer>
  );
}

export default Footer;
